import {
  SET_SATUAN_KERJAS,
  SET_SATUAN_KERJA,
  SET_SATUAN_KERJAS_ERROR,
  SET_SATUAN_KERJAS_LOADING,
} from "../../actions/satuanKerjaAction";

var initialState = {
  datas: [],
  data: "",
  loading: false,
  error: null,
};

const satuanKerjaReducer = (state, action) => {
  state = state || initialState;
  switch (action.type) {
    case SET_SATUAN_KERJAS:
      return {
        ...state,
        datas: action.data,
      };
    case SET_SATUAN_KERJA:
      return {
        ...state,
        data: action.data,
      };
    case SET_SATUAN_KERJAS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case SET_SATUAN_KERJAS_LOADING:
      return {
        ...state,
        loading: action.status,
      };
    default:
      return state;
  }
};

export default satuanKerjaReducer;
